import React from "react";
import { FormFeedback, FormGroup, Label } from "reactstrap";
import { FieldProps } from "formik";
import { DateTime } from "luxon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const ReactDatePicker: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  return (
    <FormGroup className="date-picker-formgroup">
      {props.label && (
        <Label for={name} className={"label-color"}>
          {props.label}
          {props.required && <span className="text-danger">*</span>}
        </Label>
      )}
      <DatePicker
        locale="fr"
        {...props}
        selected={value ? DateTime.fromISO(value).toJSDate() : null}
        name={name}
        placeholderText={props.placeholder}
        autoComplete="off"
        onChange={(e:any) => {
          //  console.log("DatePicker onChange: ", e);
          e
            ? setFieldValue(name, DateTime.fromJSDate(e).toUTC().toISO())
            : setFieldValue(name, null)
        }}
        dateFormat="dd/MM/yy"
      />
      {touched[name] && errors[name] ? (
        <FormFeedback>{errors[name]}</FormFeedback>
      ) : (
        ""
      )}
    </FormGroup>
  );
};

export default ReactDatePicker;
